import CMS from "@/utils/cms.ts";
import {useEffect, useRef, useState} from "react";
import {useLocation, useNavigate} from "react-router-dom";
import st from "@/styles/OfferPopups.module.scss"
import CommonClass from "@/utils/common.ts";
import {LocalLanguage} from "@/types_and_interfaces/types.ts";
import {useTranslation} from "react-i18next";
import ChevroneIcon from "@/svg/ChevroneIcon.tsx";
import CloseBtn from "@/ui/CloseButton.tsx";
import LazyImage from "@/ui/LazyImage.tsx";
import DashboardClass from "@/utils/dashboard_class.ts";
import ClickableBgOverlay from "@/ui/ClickableBgOverlay.tsx";
import clsx from "clsx";
import {Pagination} from "swiper/modules";
import {Swiper, SwiperSlide} from "swiper/react";
import eventEmitter from "@/utils/event_emmiter_instance.ts";


interface PagePromInterface {
    ts: string
    page: string
    api_id: string
}


const PromoPopup = () => {
    const effect_ran = useRef<boolean>(false)
    const location_mount = useRef<boolean>(false)
    // const timeout_ref = useRef<any>(null)
    const { i18n} = useTranslation()
    const location = useLocation()
    const navigate = useNavigate()
    const [enter_proms, set_enter_proms] = useState<Array<any>>([])
    const [on_page_proms, set_on_page_proms] = useState<Array<any>>([])
    const [can_show, set_can_show] = useState<boolean>(false)
    const promos = CMS.getCabinetOffers()
    const one_minute = 60000
    const expire_minutes = import.meta.env.MODE === 'development' ? 0.1 : 240
    // const channel = new BroadcastChannel(CommonClass.js_channels.kyc_priority);
    const total = [...enter_proms, ...on_page_proms]
    const [_swiper, setSwiper] = useState<any>();
    const [currentSlide, setCurrentSlide] = useState<number>(0);
    const queryParams = new URLSearchParams(location.search);
    const debug = queryParams.get("debug")
    
    const set_can_show_handler = (x:boolean) => {
        set_can_show(x)
    }
    
    const remove_items = (api_id:string) => {
        let prom_enter_to_delete = enter_proms.find((x) => x.api_id === api_id)
        let prom_page_to_delete = on_page_proms.find((x) => x.api_id === api_id)
        
        if(prom_enter_to_delete) {
            set_enter_proms(enter_proms.filter((x) => x.api_id !== api_id))
        }
        
        if(prom_page_to_delete) {
            set_on_page_proms(on_page_proms.filter((x) => x.api_id !== api_id))
        }
    }
    const clear_items = () => {
        set_enter_proms([])
        set_on_page_proms([])
    }
    
    const refresh_on_enter_proms_ts = () => {
        let currentDate = new Date();
        let futureDate = new Date(currentDate.getTime() + (expire_minutes * one_minute));
        localStorage.setItem(CommonClass.local_storage_fields.on_enter_proms_ts, futureDate.toISOString())
    }
    
    const handle_push_on_enter = () => {
        let matched = promos.filter((pr:any) => pr.cabinet_pop_on_enter)
        
        if(Array.isArray(matched) && matched.length) {
            set_enter_proms((x:Array<any>) => [...x, ...matched])
            refresh_on_enter_proms_ts()
        }
    }
    
    const push_on_enter_prom = () => {
        // if(!can_show) return
        
        let ts = localStorage.getItem(CommonClass.local_storage_fields.on_enter_proms_ts)
        
        if(ts === null) {
            handle_push_on_enter()
            
        } else {
            
            const futureDate = new Date(ts);
            const currentDate = new Date();
            
            if (futureDate < currentDate) {
                handle_push_on_enter()
                
            }
        }

    }
    
    const refresh_page_proms_ts = (page:any, api_id:string, delete_prev:boolean = false) => {
        
        let currentDate = new Date();
        let futureDate = new Date(currentDate.getTime() + (expire_minutes * one_minute));

        let data = localStorage.getItem(CommonClass.local_storage_fields.on_page_proms_ts)
        let parsed:Array<PagePromInterface> = data ? JSON.parse(data) : null
        
        let inject_data: PagePromInterface = {
            page: page,
            ts: futureDate.toISOString(),
            api_id
        }
        
        if(data === null) {
            localStorage.setItem(CommonClass.local_storage_fields.on_page_proms_ts, JSON.stringify([inject_data]))
        }
        
        if(typeof data === "string" && Array.isArray(parsed) && !delete_prev){
            parsed.push(inject_data)
            localStorage.setItem(CommonClass.local_storage_fields.on_page_proms_ts, JSON.stringify(parsed))
        }
        
        if(delete_prev && data !== null && Array.isArray(parsed)) {
            let index_to_remove = parsed.findIndex((x:PagePromInterface) => x.api_id === api_id)
            
            if(index_to_remove !== -1){
                parsed.splice(index_to_remove, 1);
            }
            parsed.push(inject_data)
            localStorage.setItem(CommonClass.local_storage_fields.on_page_proms_ts, JSON.stringify(parsed))
        }
    }
    
    const push_on_page_prom = () => {
        // if(!can_show) return
        if(location_mount.current) return
        let data = localStorage.getItem(CommonClass.local_storage_fields.on_page_proms_ts)
        let parsed_data: Array<PagePromInterface> | null = data ? JSON.parse(data) : null
        let matched = promos.filter((pr:any) => location.pathname.includes(pr.cabinet_pop_page))
        if(Array.isArray(matched) && matched.length) {
            let result:Array<any> = []
            matched.forEach((matched_pr:any) => {
                
                if(data !== null && Array.isArray(parsed_data) && parsed_data.length) {
                    let matched_ts = parsed_data.find((x:PagePromInterface) => matched_pr.cabinet_pop_page === x.page)
                    if(typeof matched_ts === "object") {
                        const futureDate = new Date(matched_ts.ts);
                        const currentDate = new Date();

                        if (futureDate < currentDate) {
                            refresh_page_proms_ts(matched_pr.cabinet_pop_page, matched_pr.api_id, true)
                            result.push(matched_pr)
                        }
                    }
                    
                    if(!matched_ts) {
                        refresh_page_proms_ts(matched_pr.cabinet_pop_page, matched_pr.api_id)
                        result.push(matched_pr)
                    }
                }
                
                if(data === null || (Array.isArray(parsed_data) && !parsed_data.length)) {
                    refresh_page_proms_ts(matched_pr.cabinet_pop_page, matched_pr.api_id)
                    result.push(matched_pr)
                }
            })
            set_on_page_proms(result)
            
        }
        
        location_mount.current = true
    }
    
    const nav_to_prom = (api_id:string) => {
        navigate(DashboardClass.dashboard_routes.Promo + "/" + api_id)
    }
    

    useEffect(() => {

        eventEmitter.on(CommonClass.CustomEvents.show_promo_popups, set_can_show_handler)

        if(!effect_ran.current && !location.pathname.includes(DashboardClass.dashboard_routes.KYC)) {
            
            push_on_enter_prom()

        }


        return () => {
            eventEmitter.off(CommonClass.CustomEvents.show_promo_popups, set_can_show_handler)
            effect_ran.current = true
        }
    }, []);
    
    useEffect(() => {
        location_mount.current = false
        
        let timeout = setTimeout(() => {
            if(debug==="true")console.info("setTimeout PromoPopup")
            push_on_page_prom()
            clearTimeout(timeout)
        }, 100)
        
        if(location.pathname.includes(DashboardClass.dashboard_routes.KYC)) {
            set_enter_proms([])
            set_on_page_proms([])
        }
        
    }, [location]);
    
    return can_show && (
        <div className={st.popups_container}>
            
            {total.length ? (
                <>
                    <div className={st.desktop}>
                        {total.map((prom, i:number) => {
                            
                            const pr = CMS.langAwareFilter(prom, (i18n.language as LocalLanguage))
                            
                            const {api_id} = pr
                            
                            return (
                                <PopupItem
                                    key={`active_proms_${i}`}
                                    pr={pr}
                                    anim_delay={i}
                                    remove_item={() => {
                                        remove_items(api_id)
                                    }}
                                    nav_item={() => {
                                        nav_to_prom(api_id)
                                        remove_items(api_id)
                                    }}
                                />
                            )
                        })}
                    </div>
                    
                    <div className={st.mobile}>
                        
                        <ClickableBgOverlay
                            onClick={() => {
                                clear_items()
                            }}
                            className={st.overlay}
                        />
                        
                        
                        <div className={st.inner}>
                            
                            <CloseBtn
                                dark
                                onClick={() => {
                                    clear_items()
                                }}
                                className={st.close}
                            />

                            
                            <Swiper
                                className={clsx(st.slider)}
                                pagination={{
                                    clickable: true,
                                }}
                                modules={[Pagination]}
                                allowTouchMove={true}
                                spaceBetween={0}
                                slidesPerView={1}
                                translate={"no"}
                                onSwiper={(sw) => {
                                    setSwiper(sw);
                                }}
                                onSlideChange={(swiper) => setCurrentSlide(swiper.activeIndex)}
                                
                                onNavigationNext={() => {
                                    setCurrentSlide(currentSlide + 1)
                                }}
                                onNavigationPrev={() => {
                                    setCurrentSlide(currentSlide - 1)
                                }}
                                initialSlide={currentSlide}
                            >
                                
                                {total.map((pr:any, i:number) => {
                                    const {api_id} =pr
                                    return (
                                        <SwiperSlide
                                            onClick={(e) => {
                                                e.stopPropagation()
                                                close()
                                            }}
                                            key={"full_width_slider_item"+i}
                                            className={clsx(st.slide)}
                                        >
                                            <PopupItem
                                                pr={pr}
                                                nav_item={() => {
                                                    nav_to_prom(api_id)
                                                    clear_items()
                                                }}
                                            />
                                        </SwiperSlide>
                                    )
                                })}
                            
                            </Swiper>

                        </div>
                        
                    </div>
                    
                </>
            ) : null}
            
        </div>
    )
}


interface PopupItemInterface {
    pr:any
    anim_delay?:number
    remove_item?():void
    nav_item():void
}


const PopupItem:React.FC<PopupItemInterface> = (props) => {
    
    const {
        pr,
        anim_delay,
        remove_item,
        nav_item
    } = props
    
    const {i18n} = useTranslation()
    
    const {main_image, heading} = CMS.langAwareFilter(pr, i18n.language as LocalLanguage)
    
    const {t} = useTranslation()
    
    return (
        <div
            className={clsx(st.popup, typeof anim_delay !== "number" && st.no_animated)}
            style={{
                animationDelay: `${0.2 * (typeof anim_delay === "number" ? anim_delay : 0)}s`
            }}
        >
            <div className={st.top}>
                <LazyImage
                    onClick={nav_item}
                    className={st.img}
                    src={CMS.getFilePath(main_image[0].path)}
                    alt="prom"
                />
                
                {typeof remove_item === "function" && (
                    <CloseBtn
                        dark
                        onClick={remove_item}
                        className={st.close}
                    />
                    
                )}
                
            </div>
            
            <div className={st.inf}>
                
                <div className={st.badge_container}>
                    <div className={st.badge}>
                        {t("new_offer")}
                    </div>
                </div>
                
                <h5
                    onClick={remove_item}
                >
                    {heading}
                </h5>
                
                <div
                    onClick={nav_item}
                    className={st.bottom}
                >
                    <span>
                        {t("more")}
                    </span>
                    
                    <ChevroneIcon/>
                </div>
            </div>
        </div>
    )
}

export default PromoPopup